var map = {
	"./again.svg": 124,
	"./background.svg": 399,
	"./dk-flag.svg": 400,
	"./en-flag.svg": 401,
	"./highscore/amateur.svg": 402,
	"./highscore/apprentice.svg": 403,
	"./highscore/empty-star.svg": 404,
	"./highscore/expert.svg": 405,
	"./highscore/full-star.svg": 406,
	"./highscore/grand-master.svg": 407,
	"./highscore/master.svg": 408,
	"./highscore/novice.svg": 409,
	"./icon-back.svg": 410,
	"./icon-cookies.svg": 411,
	"./icon-loading.svg": 412,
	"./icon-next-dark.svg": 413,
	"./icon-next-white.svg": 414,
	"./icon-next.svg": 415,
	"./icon-play.svg": 71,
	"./icon-x.svg": 416,
	"./igen.svg": 125,
	"./logo-cgl-dark.svg": 123,
	"./logo-dd.svg": 70,
	"./newQuiz.svg": 126,
	"./nyquiz.svg": 127
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 398;